import React, { useEffect } from "react";
import { styled } from "styled-components";
import { Row, Col, Switch, Flex } from 'antd';
import Theme from '../../styles/Theme/Theme';
import { Field } from "../../styles/global/Pages.styled";
import { Text } from "../Global/Atomics/Text";
import { useGlobalFilterContext } from "../../contexts/GlobalFilterProvider";
import i18next from "i18next";
import { useTranslation } from 'react-i18next';
import { Weather } from "../Global/Atomics/Weather";
import useFetch from "../../server/useFetch";
import { NewWidget } from "../Global/Atomics/NewWidget";
import { containerMiddlewareAdEPortoEnergy } from "../../server/constants.api";
import { unitConverter, unitConverterArrays, unitConvertSingleValue } from "../../utils/hooks/unitConverter";
//#region  Styled Components
//Where we define the styles, CSS and other aspects for the page components
const OverlayStyles = styled.div`
  height: Calc(100vh - 152px);

  > div, .ant-flex {
    height: 100%;
  }
  .overlay-widget {
    box-shadow: 0px 4px 16px 0px rgba(0, 0, 0, 0.15);
    border-radius: ${Theme.radius['lg']};

    &.field {
      padding: ${Theme.spacing.s02} ${Theme.spacing.s03};
    }
  }
`;
//#endregion

// Functional component for WidgetsOverlay
export const WidgetsOverlay = ({ showBTN, showBTE, showMT, showAT, showBTN_IP }) => {
  const { t } = useTranslation();
  // Using global filter context
  const { filterContent, entityToFetch, isToApplyFilters, classesDropdown } = useGlobalFilterContext();
  const date = new Date();
  const year = date.getFullYear();

  const {
    data: mapElectricityConsumptionData,
    isFetching: isFetchingMapElectricityConsumptionData,
    refetch: refetchMapElectricityConsumptionData
  } = useFetch('consumption/total-energy/previous-year/ELECTRICITY', 'getMapElectricityConsumptionData', {
    tenant: filterContent?.tenant,
    classes: filterContent?.classes ? findNames(classesDropdown, filterContent?.classes)?.join() : null, //Para enviar mais que uma enviar com ; (ex. Office;Lab)
    // types: 'Buildings,Infrastructures'
  }, false, null, containerMiddlewareAdEPortoEnergy);

  const {
    data: mapElectricityAnnualConsumptionData,
    isFetching: isFetchingMapElectricityAnnualConsumptionData,
    refetch: refetchMapElectricityAnnualConsumptionData
  } = useFetch('consumption/monthly/ELECTRICITY', 'getMapElectricityAnnualConsumptionData', {
    tenant: filterContent?.tenant,
    classes: filterContent?.classes ? findNames(classesDropdown, filterContent?.classes)?.join() : null, //Para enviar mais que uma enviar com ; (ex. Office;Lab)
    // types: 'Buildings,Infrastructures'
  }, false, null, containerMiddlewareAdEPortoEnergy);

  useEffect(() => {
    if (isToApplyFilters) {
      refetchMapElectricityConsumptionData();
      refetchMapElectricityAnnualConsumptionData();
    }
  }, [isToApplyFilters]);

  // Function to handle switch change for BTN
  const onChangeSwitchBTN = (checked) => {
    try {
      showBTN(checked);
    } catch (error) {
      console.error('(WidgetsOverlay page) Error in onChangeSwitch BTN:', error);
      //reportError(error); // Send error report to backend
    }
  };

  // Function to handle switch change for BTE
  const onChangeSwitchBTE = (checked) => {
    try {
      showBTE(checked);
    } catch (error) {
      console.error('(WidgetsOverlay page) Error in onChangeSwitch BTE:', error);
      //reportError(error); // Send error report to backend
    }
  };

  // Function to handle switch change for MT
  const onChangeSwitchMT = (checked) => {
    try {
      showMT(checked);
    } catch (error) {
      console.error('(WidgetsOverlay page) Error in onChangeSwitch MT:', error);
      //reportError(error); // Send error report to backend
    }
  };

  // Function to handle switch change for MT
  const onChangeSwitchAT = (checked) => {
    try {
      showAT(checked);
    } catch (error) {
      console.error('(WidgetsOverlay page) Error in onChangeSwitch AT:', error);
      //reportError(error); // Send error report to backend
    }
  };

  // Function to handle switch change for MT
  const onChangeSwitchBTN_IP = (checked) => {
    try {
      showBTN_IP(checked);
    } catch (error) {
      console.error('(WidgetsOverlay page) Error in onChangeSwitch AT:', error);
      //reportError(error); // Send error report to backend
    }
  };

  return (
    // Overlay styles
    <OverlayStyles>
      <Row>
        <Col span={6}>
          {/* Flex container */}
          <Flex vertical justify='space-between' gap="middle">
            <Row gutter={[Theme.spacing['s03'], Theme.spacing['s03']]}>

              {/* Widgets */}
              <Col span={24}>
                <Weather tenant={entityToFetch?.name} isToApplyFilters={isToApplyFilters} />
              </Col>
              <Col span={24} className="overlay-widget">
                <NewWidget data={{
                  // height: '150px',
                  background: 'white',
                  title: 'electricityConsumption',
                  icon: 'Bolt',
                  tooltip: t('mapOverlayTooltip'),
                  charts: [
                    {
                      chartType: 'bigNumberChart',
                      isFetching: isFetchingMapElectricityAnnualConsumptionData,
                      data: mapElectricityAnnualConsumptionData?.data ? getMapElectricityConsumption(mapElectricityAnnualConsumptionData?.data, year) : null
                    }
                  ],
                }} filters={filterContent} language={i18next.resolvedLanguage} />
              </Col>
              <Col span={24} className="overlay-widget">
                <NewWidget data={{
                  background: 'white',
                  title: 'monthlyElectricityConsumption',
                  icon: 'Bolt',
                  charts: [
                    {
                      height: '250px',
                      chartType: 'mixedLineColumnChartApex',
                      isFetching: isFetchingMapElectricityConsumptionData,
                      data: mapElectricityConsumptionData?.data?.currentData ? getMonthlyElectricityConsumption(mapElectricityConsumptionData?.data, year, t) : null
                    }
                  ]
                }} filters={filterContent} language={i18next.resolvedLanguage} />
              </Col>
            </Row>
            <Row>
              <Col>
                {/* Switches for BTN, BTE, and MT */}
                <Field $backgroundColor="white" className="overlay-widget field">
                  <Flex gap="middle" align="start" horizontal="true" >
                    <Flex gap="small" align="center" horizontal="true" >
                      <Switch defaultChecked size="small" onChange={onChangeSwitchBTN} />
                      <Text $fontColor='coolgray-12' $fontSize='text_xs' $weight='regular'>BTN</Text>
                    </Flex>
                    <Flex gap="small" align="center" horizontal="true" >
                      <Switch defaultChecked size="small" onChange={onChangeSwitchBTN_IP} />
                      <Text $fontColor='coolgray-12' $fontSize='text_xs' $weight='regular'>BTN-IP</Text>
                    </Flex>
                    <Flex gap="small" align="center" horizontal="true" >
                      <Switch defaultChecked size="small" onChange={onChangeSwitchBTE} />
                      <Text $fontColor='coolgray-12' $fontSize='text_xs' $weight='regular'>BTE</Text>
                    </Flex>
                    <Flex gap="small" align="center" horizontal="true" >
                      <Switch defaultChecked size="small" onChange={onChangeSwitchMT} />
                      <Text $fontColor='coolgray-12' $fontSize='text_xs' $weight='regular'>MT</Text>
                    </Flex>
                    <Flex gap="small" align="center" horizontal="true" >
                      <Switch defaultChecked size="small" onChange={onChangeSwitchAT} />
                      <Text $fontColor='coolgray-12' $fontSize='text_xs' $weight='regular'>AT</Text>
                    </Flex>
                  </Flex>
                </Field>
              </Col>
            </Row>
          </Flex>

        </Col>
      </Row>
    </OverlayStyles >

  );
};

function findNames(array1, array2) {
  const result = [];

  array2.forEach(value => {
    array1.forEach(group => {
      group.options.forEach(option => {
        if (option.value === value) {
          result.push(`${group.name}_${option.value}`);
        }
      });
    });
  });

  return result;
}

const getMapElectricityConsumption = (data, year) => {
  const { result, newUnit } = unitConvertSingleValue(data?.value, data?.unit);

  return {
    number: result,
    unit: newUnit,
    fluctuation: data.fluctuation && !isNaN(data.fluctuation) ? data.fluctuation.toFixed(2) : null,
    fluctuationText: data.fluctuation ? year - 1 : null
  }
};

const getMonthlyElectricityConsumption = (data, year, t) => {
  const currentData = data.currentData ? Object.values(data.currentData) : [];
  const homologousData = data.homologousData ? Object.values(data.homologousData) : [];
  const {convertedResult, newUnit} = unitConverterArrays([currentData, homologousData], data.unit);

  const series = [{
    name: year,
    type: 'column',
    data: convertedResult[0]
  }, {
    name: year - 1,
    type: 'line',
    data: convertedResult[1]
  }];
  const labels = Object.keys(data.currentData).map(x => t(x));

  return {
    series: series,
    categories: null,
    // xAxisType: "datetime",
    yAxisLabelRotate: -90,
    labelFormat: "dd/MM",
    tooltip: "dd/MM/yyyy",
    // markerSize: 3,
    unit: newUnit,
    yAxisLabel: newUnit,
    // columnWidth: 20,
    colors: series?.map((x, index) => { return Theme.color[`chart-base-${index + 1}`] }),
    labels: labels,
    markersSize: [6, 6],
    // hideToolbar: true,
    tickAmount: 6
  }
};